import { createSelector } from 'reselect';
 
const selectOrgRegistries = (state: any) => state.orgRegistries;
 
export const selectOrgRegistriesCurrentItem = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.current);
 
export const selectOrgRegistriesListItems = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.list);
 
 
export const selectOrgRegistriesItemById = (itemId: any) =>
    createSelector(selectOrgRegistriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectOrgRegistriesQueryItems = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.query);

export const selectOrgRegistriesCreatedItem = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.create);
 
export const selectOrgRegistriesUpdatedItem = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.update);
 
export const selectOrgRegistriesReadItem = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.read);
 
export const selectOrgRegistriesDeletedItem = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.delete);
 
export const selectOrgRegistriesSearchedItems = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.search);
 
export const selectOrgRegistriesItemsCount = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.count);
 
export const selectOrgRegistriesItemsFilter = createSelector([selectOrgRegistries], (orgRegistries) => orgRegistries.filter);